// extracted by mini-css-extract-plugin
export var actions = "_6f-8";
export var arrow = "_6f-5";
export var card = "_6f-0";
export var cardWrapper = "_6f-9";
export var fieldName = "_6f-3";
export var newValue = "_6f-6";
export var oldValue = "_6f-4";
export var orangeGlowFade = "_6f-c";
export var productSection = "_6f-1";
export var scrollToBottom = "_6f-b";
export var scrollToBottomAnchor = "_6f-a";
export var scrollToBottomIcon = "_6f-d";
export var showAllButton = "_6f-7";
export var table = "_6f-2";